module.exports = __webpack_public_path__ + "static/media/orders.98d6925f.svg";